export function downloadBase64(base: string, fileName: string): void {
    const linkSource = `data:application/pdf;base64,${base}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

export function downloadFormData(file: Blob, fileName: string): void {
  const url = URL.createObjectURL(file);
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = fileName;
  downloadLink.click();
  URL.revokeObjectURL(url);
}
